<template>
<div>
    <v-snackbar bottom  dark color="green darken-2" style="z-index:99999"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
   <v-container>
       <v-row>
           <div style="    width: 100%;">
           
             <b-card
  v-if="!regStatus"
    no-body
    style="width: 100%"
  >
    <!-- <b-card-img style="width:100%" src="https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png" alt="Image" middle></b-card-img> -->
    <template v-slot:header>
      <h4 class="mb-0">Guest User</h4>
    </template>
     <b-card-body style="text-align:left">
     
      <b-card-text style="text-align:center;">
          <p>Create an account to get best offers and deals..!</p>
       <v-btn success style="background:#ffc107b8;margin-right:10px;" @click="regUser">Sign Up</v-btn>
       <v-btn success style="background:#17a2b8ba;" @click="login">Sign In</v-btn>
      </b-card-text>
    </b-card-body>

   </b-card>
          
  <b-card
  v-if="regStatus"
    no-body
    style="max-width: 100%"
  >
   <div style="text-align:center;" class="mx-auto">
      <v-img :src="cardprofile.img"></v-img>
   </div>
   
    

    <b-card-body style="text-align:center;font-family: roboto;">
      <b-card-title style="text-align:center"><b style="font-size:15px;">Welcome </b><span style="color:#28a745;">{{cardprofile.uname}}</span></b-card-title>
      <!-- <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title>
      <b-card-text>
        Some quick example text to build on the card title and make up the bulk of the card's
        content.
      </b-card-text> -->

      <b-card-sub-title class="mb-2">
      <!-- <b-button class="btn-xs btn" variant="outline-primary" style="    margin-right: 10px;" @click="edit">Edit</b-button>
       <b-button  variant="outline-warning" @click="logout">Logout</b-button> -->
       <button class="btn-md btn btn-success"  style="margin-right: 10px;"   @click="edit" ><v-icon>mdi-account-edit</v-icon></button>
      <button class="btn-xs btn btn-danger"  @click="logout"><v-icon>mdi-logout</v-icon></button>
      </b-card-sub-title>
    </b-card-body>

    

  
  </b-card>
</div>
       </v-row>
   </v-container>

   

  <!-- modal -->

  

  <b-modal id="modal-scrollable" ref="my-modal" scrollable title="Create Account" hide-footer>
        <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.name" size="sm" placeholder="Name*" autofocus ></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.mob" type="number" size="sm" placeholder="Mobile No*" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.amob" type="number" size="sm" placeholder="Phone No" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.mailid" type="email" size="sm" placeholder="Email Id" focus></b-form-input>
        </v-col>

     
    
         
        <v-col cols="12" sm="6" md="3">
          <b-button variant="danger" size="sm">Cancel</b-button>&nbsp;
          <b-button  variant="success" size="sm" @click="postCustomer">Proceed</b-button>
        </v-col>
      </v-row>
        </v-container>
  </b-modal>

  <!-- modal -->

  <!-- log modal -->
   <b-modal id="modal-scrollable" ref="log-modal" scrollable title="Sign IN" hide-footer>
        <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="log.uname" size="sm" placeholder="username*" autofocus ></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="log.pass" type="password" size="sm" placeholder="password" ></b-form-input>
        </v-col>
       

     
    
         
        <v-col cols="12" sm="6" md="3">
          <!-- <b-button variant="danger" size="sm" @click="clslogin">Cancel</b-button>&nbsp; -->
          <b-button  variant="success" size="sm" @click="authlogin">Login</b-button>
        </v-col>
      </v-row>
        </v-container>
  </b-modal>
  </div>
  
  
</template>

<script>
import Router from '../router';
 import Loading from 'vue-loading-overlay';
  import axios from 'axios';
  import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {
            Loading
        },
        data: () => ({
            name: 'Profile',
            Profile : [],
            regStatus : false,
            imgURL:'',
            currency:'',
            isLoading: false,
            fullPage: true,
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            log:{
              uname:'',
              pass:''
            },
            customer:{
          name:'',
          mob:'',
          amob:'',
          mailid:'',
          address:'',
          landmark:'',
          orderitems:[],
          pin:'',
          town:'',
          state:'',
          addresstype:'',
          createdDate:'',
          remarks:'',
          geoLocation:''
         

      },
      cardprofile:{
        uname:'',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSFg8Mrh5_UXJUKrTtLNVcMPYeoVGNu9yn0WA&usqp=CAU',

      },
      obj:[]

        }),

        mounted(){
          if (localStorage.getItem("islogedIn") !== null) {
              this.regStatus = localStorage.getItem("islogedIn");

              this.obj = JSON.parse(localStorage.getItem("Logeduser"))

              this.cardprofile.uname = this.obj[0].Username
            }
             
             this.imgURL = localStorage.getItem("imgUrl");
             this.currency = localStorage.getItem("currency");
        },
        methods: {
          edit(){
                   Router.push('/updateprofile');
          },
           logout(){
                // console.log("ss")
               localStorage.removeItem("Logeduser")
               localStorage.removeItem("islogedIn")
               localStorage.removeItem("logeduserId")
                Router.push('/account');
              
           },
            regUser(){
               Router.push('/register');
              // this.showModal() 
              
            },
            login(){
              Router.push('/login');
              // this.logshowModal() 
              // login
            },
            logshowModal(){
               this.$refs['log-modal'].show()
            },
            clsmodal(){
               this.$refs['log-modal'].hide()
            },
            showModal() {
                this.$refs['my-modal'].show()
            },
             hideModal() {
                this.$refs['my-modal'].hide()
             },


             authlogin(){


               if(!this.log.uname)
              {
               this.snackbar = {
                        message: "Please fill in the  username field.",
                        color: 'success',
                        show: true
                    }
              }else if(!this.log.pass){
                  this.snackbar = {
                        message: "Please fill in the password field.",
                        color: 'success',
                        show: true
                    }
               }else{
                   this.isLoading = true;
                 axios.post(this.$bURL+"registeredcustomer/Authenticate",this.log)
      .then((response)  =>  {
       console.log(response.data)
     
       this.clsmodal();

       this.isLoading = false

               localStorage.setItem("Logeduser",JSON.stringify(response.data))
               localStorage.setItem("islogedIn",true)
               localStorage.setItem("logeduserId",this.log.uname)

      
      }, (error)  =>  {
          console.log(error)
          this.snackbar = {
                        message: error,
                        color: 'danger',
                        show: true
        }
                    this.isLoading = false
      })
               }

             },
             //--------------------------

             postCustomer(){

    if(!this.customer.name)
    {
             this.snackbar = {
                        message: "Please fill in the  Name field.",
                        color: 'success',
                        show: true
                    }
    }else if(!this.customer.mob){
      this.snackbar = {
                        message: "Please fill in the  Mobile field.",
                        color: 'success',
                        show: true
                    }
    }
    else if(!this.customer.town){
      this.snackbar = {
                        message: "Please fill in the  Address field.",
                        color: 'success',
                        show: true
                    }
    }
    else if(!this.customer.addresstype){
      this.snackbar = {
                        message: "Please choose your Address Type: Home or Work",
                        color: 'success',
                        show: true
                    }
    }
    
    else{



  this.isLoading = true;
      this.cusobj =
        {
	
	"customerName": this.customer.name,
	"mobile": this.customer.mob,
	"phone": this.customer.amob,
	"email": this.customer.mailid,
	"houseNo": this.customer.address,
	"area": this.customer.landmark,
	"city": this.customer.town,
	"state": this.customer.state,
	"piNcode": this.customer.pin,
	"remarks": this.customer.remarks,
	"addressType": this.customer.addresstype,
	"geoLocation": "",
	"username": ""

      }
       //localStorage.setItem("this.cusobj",JSON.stringify(this.cusobj));
      axios.post(this.$bURL+"OnlineOrder/PostOnlineCustomer",this.cusobj)
      .then((response)  =>  {
       console.log(response.data)
     
       this.hideModal();

       this.isLoading = false

      
      }, (error)  =>  {
          console.log(error)
          this.snackbar = {
                        message: error,
                        color: 'danger',
                        show: true
        }
                    this.isLoading = false
      })

    }
      
    },

    addUserAuth(){
        axios.post(this.$bURL+"OnlineOrder/PostOnlineCustomer",this.cusobj)
      .then((response)  =>  {
       console.log(response.data)
     

      
      }, (error)  =>  {
          console.log(error)
          this.snackbar = {
                        message: error,
                        color: 'danger',
                        show: true
        }
                    // this.isLoading = false
      })
    }


             //--------------------------

        }
}
</script>
<style scoped>
.modal-footer{
    display: none !important;
}
</style>